export const RelocationContract  = {
    async index(page, per_page, search) {
        page;
        per_page;
        search;
        
        throw new Error("index not implemented");
    },
    
    async relocate_all_in_location(location_id) {
        location_id;
        throw new Error("relocate_all_in_location not implemented");
    },

    async get_locations(client_id, occupied) {
        client_id;
        occupied;
        throw new Error('relocate get locations not implemented');
    },

    async get_products_by_location(location_id) {
        location_id;
        throw new Error('relocate get products by location not implemented');
    },

    async relocate(data) {
        data;
        throw new Error ('Relocate not implemented');
    },

    async validate_location(pallet_epc) {
        pallet_epc;
        throw new Error ('Relocations validate location not implemented')
    }
}